import React, { useState } from 'react'
import Card from '../../components/bootstrap/Card';
import config from "../../config";
import Icon from '../../components/icon/Icon';

const FileList = props => {
  const [files] = useState(props.files)

  return (
    <React.Fragment>
      { files.length > 0 &&
        <Card className="p-2 mb-2">
          <div className="d-flex align-items-center">
            <div className="file-box-icon">
              <Icon icon={'Assignment'} className='text-muted'/>
            </div>
            <div className="flex-1 file-box-info">
              <div className="text-start">
                <p className="font-size-14 mb-1">{files[0].title}</p>
                <p className="text-muted font-size-13 mb-0">{files[0].description}</p>
              </div>
            </div>

            <div className="ms-4 file-box-icon">
              <ul className="list-inline mb-0 font-size-20">
                {files[0].title_link_download &&
                  <li className="list-inline-item">
                    <a href={config.CHAT_URL + files[0].title_link} className="text-muted">
                      <Icon icon={'FileDownload'} className="text-muted"/>
                    </a>
                  </li>
                }
                {/* <UncontrolledDropdown tag="li" className="list-inline-item">
                  <DropdownToggle tag="a" className="dropdown-toggle text-muted">
                    <i className="ri-more-fill"></i>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>{t('Share')} <i className="ri-share-line float-end text-muted"></i></DropdownItem>
                    <DropdownItem>{t('Delete')} <i className="ri-delete-bin-line float-end text-muted"></i></DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}
              </ul>
            </div>
          </div>
        </Card>
      }
    </React.Fragment>
  )
}

export default FileList